import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AppBaseLayout } from "./_app/-components/AppBaseLayout";

export const Route = createFileRoute("/_auth/app/_app")({
	beforeLoad: ({ context }) => {
		if (!context.get_token()) {
			throw new Error("Not authenticated");
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<AppBaseLayout>
			<Outlet />
		</AppBaseLayout>
	);
}
